import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import lang from "../i18n/lang";

interface ErrorDialogProps {
  open: boolean;
  message?: string;
  onClose: () => void;
}

const ErrorDialog = ({ open, message, onClose }: ErrorDialogProps) => {
  const handleClose = (event?: {}, reason?: string) => {
    // Only allow closing via button click, not backdrop or escape key
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      BackdropProps={{
        sx: {
          backgroundColor: "#f44336",
          opacity: 1,
          pointerEvents: "auto",
        },
        onClick: (e) => {
          // Prevent closing on backdrop click
          e.stopPropagation();
        },
      }}
      PaperProps={{
        sx: {
          backgroundColor: "#fff",
          color: "#000",
          m: { xs: 2, sm: 3 },
          maxWidth: { xs: "calc(100% - 32px)", sm: "600px" },
        },
      }}
      sx={{
        "& .MuiDialog-container": {
          alignItems: { xs: "flex-end", sm: "center" },
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexWrap: { xs: "wrap", sm: "nowrap" },
          pb: { xs: 1, sm: 2 },
        }}
      >
        <ErrorIcon color="error" sx={{ fontSize: { xs: 32, sm: 40 } }} />
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "1.25rem", sm: "1.5rem" },
          }}
        >
          {lang("scan.failed")}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: { xs: 1, sm: 2 } }}>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "0.9rem", sm: "1rem" },
            wordBreak: "break-word",
          }}
        >
          {message || lang("scan.error")}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          p: { xs: 2, sm: 2 },
          pt: { xs: 1, sm: 2 },
          flexDirection: "column",
        }}
      >
        <Button
          onClick={() => handleClose()}
          variant="contained"
          color="error"
          size="large"
          fullWidth
          sx={{
            minHeight: { xs: "48px", sm: "36px" },
            fontSize: { xs: "1rem", sm: "0.875rem" },
          }}
        >
          {lang("scan.retry")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
